import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import Welcome from "./Welcome";
import config from "../config/config";

function Home() {
  const [status, setStatus] = useState("");

  useEffect(() => {
    const baseURL = config.API_BASE_URL;
    fetch(`${baseURL}/v1/auth/test`)
      .then((response) => response.text())
      .then((data) => {
        setStatus(data);
      })
      .catch((error) => {
        setStatus("Failed to connect to the backend");
      });
  }, []);

  return (
    <div className="home">
      {/* <Navbar /> */}
      <Welcome />
    </div>
  );
}

export default Home;
